import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Row, Col, FormControl, FormLabel } from 'react-bootstrap'
import { Circles } from 'react-loader-spinner'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { handleKeyPressRestrictLeadingTrailingSpace, nullAndUndefinedCheck } from '../../utils/helper'
import { Controller } from 'react-hook-form'
// getAppealStatus
function AppealModal({ showAppealModal, handleShowAppealModal, ModalHeader, citation, isAppealRequest, onSubmitAppealVoid, appealData, errors, control, is_void_exist, is_closed_exist, voidRemarks = '', setErrorForm2 }) {
    const isAppealInitiated = (nullAndUndefinedCheck(appealData) && Object.keys(appealData)?.length > 0) && appealData?.appeal_status == '4' || is_void_exist || is_closed_exist

    return (
        <Modal show={showAppealModal} onHide={handleShowAppealModal} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>{ModalHeader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col><b>Citation</b>: {citation}</Col>
                    {/* <Col><b>Status</b>:{getAppealStatus(appealData?.appeal_status || (is_void_exist) ? 1 : 0)}</Col>     */}
                    {/* <Col><b>Status</b>: {getAppealStatus((nullAndUndefinedCheck(appealData?.appeal_status)) ? appealData?.appeal_status : (is_void_exist) ? 1 : 0)}</Col> */}
                </Row>
                <Row>
                    <Col>
                        <FormLabel>
                            Email <span className='text-danger'>*</span>
                        </FormLabel>
                        <Controller
                            name='email'
                            control={control}
                            rules={{
                                required: 'This field is required',
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: 'Invalid email address'
                                }
                            }}
                            render={({ field }) => (
                                <FormControl
                                    type="email"
                                    placeholder="Enter your email"
                                    maxLength={40}
                                    minLength={1}
                                    disabled={citation === undefined || citation === null || citation === ''}
                                    {...field}
                                    value={field.value ?? ''} // Ensure always a string, never undefined
                                    onKeyPress={handleKeyPressRestrictLeadingTrailingSpace}
                                />
                            )}
                        />

                        {errors?.email?.type === 'required' && (
                            <span className='text-danger header-s form-text'>This field is required</span>
                        )}
                        {errors?.email?.type === 'pattern' && (
                            <span className='text-danger header-s form-text'>{errors?.email?.message}</span>
                        )}
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <FormLabel>Remarks <span className='text-danger'>*</span></FormLabel>
                        <Controller
                            name='remarks'
                            type="text"
                            id="remarks"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (<FormControl as="textarea" defaultValue={appealData?.user_remark || voidRemarks} placeholder="Leave a remarks here" style={{ height: '100px' }} disabled={isAppealInitiated} {...field} onChange={(e) => {
                                const value = e.target.value // Get the input value
                                const wordCount = value.trim().split(/\s+/).length // Count words in the input
                                if (wordCount <= 50) {
                                    field.onChange(e) // Call react-hook-form's onChange if word count is <= 50
                                } else {
                                    setErrorForm2(field?.name, { type: 'maxLimit', message: 'You can not enter more than 50 words.' })
                                }
                            }} />)} />
                        {errors?.remarks?.type === 'required' && <span className='text-danger header-s form-text'>This field is required</span>}
                        {errors?.remarks?.type === 'maxLimit' && <span className='text-danger header-s form-text'>{errors?.remarks?.message}</span>}
                    </Col>
                </Row>
            </Modal.Body>
            {!isAppealInitiated && (
                <Modal.Footer>
                    <Button variant="primary" type="button" className="btn btn-primary" disabled={isAppealRequest} onClick={onSubmitAppealVoid}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <span>Submit </span>
                            <span className='ms-2'>{isAppealRequest && (<Circles height="20" width="20" style={{ display: 'inline-block' }} color="#ffffff" ariaLabel="circles-loading" visible={true} />)}</span>
                        </div>
                    </Button>
                    <Button variant="secondary" onClick={handleShowAppealModal}>Close</Button>
                </Modal.Footer>
            )}
        </Modal>
    )
}

AppealModal.propTypes = {
    showAppealModal: PropTypes.bool.isRequired,
    handleShowAppealModal: PropTypes.func.isRequired,
    ModalHeader: PropTypes.string.isRequired,
    citation: PropTypes.string.isRequired,
    isAppealRequest: PropTypes.bool,
    onSubmitAppealVoid: PropTypes.func.isRequired,
    appealData: PropTypes.object,
    errors: PropTypes.object,
    control: PropTypes.object.isRequired,
    is_void_exist: PropTypes.bool.isRequired,
    voidRemarks: PropTypes.string,
    is_closed_exist: PropTypes.bool.isRequired,
    setErrorForm2: PropTypes.func.isRequired
}

AppealModal.defaultProps = {
    appealData: EMPTY_OBJECT,
    errors: EMPTY_OBJECT,
    voidRemarks: '',
    isAppealRequest: false,
}

export default AppealModal
